import { createSlice } from '@reduxjs/toolkit';
import {
    loginUser, searchUsername, searchUserbyAsset, getUserAccess,
    getUserMapCreditData, updateUserMapCredits, addOwnGoogleKey,
    adhocCredit, changePassword
} from './userApi';

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        username: null,
        userid: null,
        parentid: null,
        token: null,
        refreshToken: null,
        sockHost: null,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
        isAdmin: false,
        isSubAccount: false,
        isUser: false,
        searchedUsers: [],
        searchingUsers: false,
        needFirstLoad: false,
        googleMapKey: null,
        googleMapDevKey: null,
        googleKeyError: null,
        googleMapKeySource: null,
        mapUserCredit: {},
        googleMapdayBalance: 0,
        googleMapmonthBalance: 0,
        googleMapdayLimit: 0,
        googleMapmonthLimit: 0,
        hasGoogleAccess: 0,
        priviledge: null,
        parent_user: null,
        reports: [],
        advancedFeatures: [],
    },
    reducers: {
        clearState: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isFetching = false;
            return state;
        },
        logout: (state) => {
            state.username = '';
            state.userid = '';
            state.token = '';
            state.refreshToken = '';
            state.sockHost = '';
            state.advancedFeatures = [];
            state.isError = false;
            state.isSuccess = false;
            state.isFetching = false;
            return state;
        },
        setNeedFirstLoad: (state, { payload }) => {
            state.needFirstLoad = payload;
            return state;
        }

    },
    extraReducers: {
        [loginUser.fulfilled]: (state, { payload }) => {
            if (payload.token && payload.hosts) {
                state.username = payload.username;
                state.userid = payload.userid;
                state.parentid = payload.parent_user;
                state.token = payload.token;
                state.refreshToken = payload.refreshToken;
                state.sockHost = `${payload.hosts.sockHost}`;
                state.isAdmin = payload.admin;
                state.isSubAccount = payload.priviledge === 'subuser' ? true : false;
                state.isUser = payload.priviledge === 'user' ? true : false;
                state.googleMapKey = payload.googleMapKey;
                state.googleMapDevKey = payload.googleMapDevKey;
                state.googleKeyError = payload.keyError;
                state.googleMapKeySource = payload.googleMapKeySource;
                state.googleMapdayConsumed = payload.dayConsumed;
                state.googleMapmonthConsumed = payload.monthConsumed;
                state.googleMapdayLimit = payload.dayLimit;
                state.googleMapmonthLimit = payload.monthLimit;
                state.hasGoogleAccess = payload.hasGoogleAccess;
                state.isError = false;
                state.isSuccess = true;
                state.isFetching = false;
                state.priviledge = payload.priviledge;
                state.parent_user = payload.parent_user;
                state.reports = payload.reports;
                state.advancedFeatures = payload.advancedFeatures || [];
                //console.log("User Logged in - reducer", payload);

            } else {
                state.isError = true;
                state.isSuccess = false;
                state.isFetching = false;
                if (payload.error) {
                    state.errorMessage = payload.error;
                }
                //console.log("User Logged in - reducer", state);
            }
            return state;
        },
        [loginUser.rejected]: (state, { payload }) => {
            //console.log("Reject payload", payload);
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = "Login failed";
        },
        [loginUser.pending]: (state) => {
            state.isFetching = true;
        },
        [searchUsername.fulfilled]: (state, { payload }) => {
            //console.log("user search", payload);
            state.searchedUsers = payload;
            state.searchingUsers = false;
            return state;
        },
        [searchUsername.pending]: (state) => {
            state.searchingUsers = true;
            return state;
        },
        [searchUserbyAsset.fulfilled]: (state, { payload }) => {
            //console.log('asset search', payload);
            state.searchedUsers = payload;
            state.searchingUsers = false;
            return state;
        },
        [searchUserbyAsset.pending]: (state) => {
            state.searchingUsers = true;
            return state;
        },
        [getUserAccess.fulfilled]: (state, { payload }) => {
            if (payload.token && payload.hosts) {
                state.username = payload.username;
                state.userid = payload.userid;
                state.token = payload.token;
                state.refreshToken = payload.refreshToken;
                state.sockHost = `${payload.hosts.sockHost}`;
                state.isAdmin = payload.admin;
                state.advancedFeatures = payload.advancedFeatures || [];
                state.isError = false;
                state.isSuccess = true;
                state.isFetching = false;

            } else {
                state.isError = true;
                state.isSuccess = false;
                state.isFetching = false;
                if (payload.error) {
                    state.errorMessage = payload.error;
                }
            }
            //console.log("User Logged in - reducer");
            return state;
        },
        [getUserAccess.rejected]: (state, { payload }) => {
            //console.log("Reject payload", payload);
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = "Login failed";
        },
        [getUserMapCreditData.fulfilled]: (state, { payload }) => {
            //console.log("Crediy payload", payload);
            state.mapUserCredit = payload;
            return state;
        }
    },
})

export {
    loginUser, searchUsername, searchUserbyAsset, getUserAccess,
    getUserMapCreditData, updateUserMapCredits, addOwnGoogleKey,
    adhocCredit, changePassword
};
export const { clearState, logout, setNeedFirstLoad } = userSlice.actions;
export const userSelector = (state) => state.user;
export const useridSelector = state => state.user.userid;
export const sockHostSelector = state => state.user.sockHost;
export const usernameSelector = state => state.user.username;
export const googleMapKeySelector = state => state.user.googleMapKey;
export const googleMapDevKeySelector = state => state.user.googleMapDevKey;
export const googleKeyErrorSelector = state => state.user.googleKeyError;
export const mapUserCreditSelector = state => state.user.mapUserCredit;
export const googleMapKeySourceSelector = state => state.user.googleMapKeySource;
export const hasGoogleAccessSelector = state => state.user.hasGoogleAccess;
